import { SettingOutlined } from '@ant-design/icons'
import { Theme, useTheme } from '@app/providers/theme-provider'
import { useChannels } from '@entities/channel'
import { EmployeeChannelRole } from '@entities/channel/model/types'
import { useCurrentUser } from '@entities/user/model/hooks/use-current-user'
import type { MenuProps } from 'antd'
import { Avatar, Button, Dropdown, Flex, Layout, Select, Skeleton, Space, theme } from 'antd'
import { memo, useMemo } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './styled.css'
const { Header } = Layout

export const Navbar = memo(() => {
    const { user, isLoading, logout } = useCurrentUser()
    const navigate = useNavigate()
    const projectTheme = useTheme()
    const isLightTheme = useMemo(() => projectTheme.theme === Theme.LIGHT, [theme])

    const {
        token: { colorBgLayout, colorBgContainer }
    } = theme.useToken()
    const items: MenuProps['items'] = useMemo(
        () => [
            {
                key: '1',
                label: <Link to="/profile">Профиль</Link>
            },
            {
                key: '4',
                danger: true,
                label: 'Выйти',
                onClick: () => logout()
            }
        ],
        [logout]
    )

    const {
        channels,
        currentChannel,
        channelDetails,
        actions: { setCurrentChannel }
    } = useChannels()

    const onChange = (id: number) => {
        setCurrentChannel(channels?.find((c) => c.id === id) ?? null)
    }

    return (
        <Header style={{ backgroundColor: colorBgLayout, borderBottom: `1px solid ${colorBgContainer}` }}>
            <Flex justify="space-between" align="center" style={{ height: '100%' }}>
                <Flex align="center">
                    {!user?.isAnonymous && (
                        <>
                            <Select<number>
                                showSearch
                                className={isLightTheme ? '' : 'custom-styles'}
                                value={currentChannel?.id}
                                placeholder="Выберите канал"
                                popupMatchSelectWidth={false}
                                onChange={onChange}
                            >
                                {channels?.map((c) => (
                                    <Select.Option value={c.id} key={c.id}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <Avatar src={c.photoUrl} size={24} />
                                            {c.name}
                                        </div>
                                    </Select.Option>
                                ))}
                            </Select>
                            {channelDetails?.role === EmployeeChannelRole.owner && (
                                <Button
                                    onClick={() => navigate('/settings')}
                                    style={{ marginLeft: 10 }}
                                    shape="circle"
                                    icon={<SettingOutlined />}
                                />
                            )}
                        </>
                    )}
                </Flex>
                {isLoading ? (
                    <Space align="center">
                        <Skeleton.Avatar style={{ verticalAlign: 'middle' }} active={true} size="default" />
                        <Skeleton.Input style={{ verticalAlign: 'middle' }} active={true} size="default" />
                    </Space>
                ) : user?.isAnonymous ? (
                    <Button onClick={() => logout()} type="primary">
                        Войти
                    </Button>
                ) : (
                    <Dropdown trigger={['click']} menu={{ items }}>
                        <Space>
                            <Avatar src={user?.photoUrl}></Avatar>
                            <span>{`${user?.firstName ?? ''} ${user?.lastName ?? ''}`}</span>
                        </Space>
                    </Dropdown>
                )}
            </Flex>
        </Header>
    )
})
